import CustomContextPad from "./my-pad-provider";
import MyPaletteProvider from "./my-pallete-provider";

export default {
  __init__: ["customContextPad", "myPaletteProvider"],
  customContextPad: [ 'type', CustomContextPad ],
  myPaletteProvider: ["type", MyPaletteProvider]
};
